// extracted by mini-css-extract-plugin
export default {"box":"blogsFilterPage_box__7Xs7p","box__content":"blogsFilterPage_box__content__Z1hYG","box__btn":"blogsFilterPage_box__btn__GkY-i"};